import {
  FETCH_CASH_ORDER,
  RESET_CASH_ORDER,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const cashOrderViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CASH_ORDER:
      return { data: action.payload };
    case RESET_CASH_ORDER:
      return initialState;
    default:
      return state;
  }
};

export default cashOrderViewReducer;
